import { setLocalStorageData, clearLocalStorageData, STORAGE_KEY } from 'services/localStorage.service'

import { ActionType, SET_USER_ROLE, UserActions } from './actions'
import { UserState } from './state'

export function userStateReducer(state: UserState, action: UserActions): UserState {
  switch (action.type) {
    case ActionType.SET_USER_ROLE: {
      let adminRole = false

      if (action.payload.token) {
        setLocalStorageData(STORAGE_KEY.USER_TOKEN, action.payload.token)
        adminRole = true
      } else {
        clearLocalStorageData(STORAGE_KEY.USER_TOKEN)
      }

      return {
        ...state,
        adminRole,
      }
    }
    default:
      return state
  }
}

export const setUserRole = (token?: string): SET_USER_ROLE => ({
  type: ActionType.SET_USER_ROLE,
  payload: { token },
})
